export const brandName = 'Accounts'
export const BACKENDURL = 'https://twinb.prosevo.com';


